import React, { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Grid, Paper, useMediaQuery } from '@mui/material';
import Titlebar from '../TitleBar';
import { Pagination, SearchTable, TableBody3, TableBottom2, TableHeader } from '.';
import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import { applyFilter, emptyRows, getComparator, extractDate } from '../../Utils/table';
import { AdminSaleMenu, adminSaleReport, UserSaleMenu } from '../TitleList';
import { selectStudents, selectSubUser, selectUserSaledata } from '../Selectors/Master/OutwardSelectors';
import { fetchUserSaleData, fetchUserSaleReport } from '../../Store/PHPSlice/stockApi';
import DateInputComponent2 from '../FieldsComponents/DateInputComponent2';
import styled, { inputStyles } from '../../Utils/inputChanges';
import Dropdown from '../FieldsComponents/Dropdown';
import { fetchStudentData, fetchSubUser } from '../../Store/PHPSlice/zone';
import axios from 'axios';
import ReactToPrint from 'react-to-print';

const UserSaleReportReg = () => {
    const userdata = JSON.parse(sessionStorage.getItem('user'));
    const componentRef = useRef();
    const dispatch = useDispatch();
    const getItems = useSelector(selectUserSaledata);
    const subusers = useSelector(selectSubUser);
    const isDesktop = useMediaQuery('(min-width:768px)');
    const baseUrl = process.env.REACT_APP_BASE_URL;
    const [order, setOrder] = useState('asc');
    const [orderBy, setOrderBy] = useState('empId');
    const [selected, setSelected] = useState([]);
    const [filterName, setFilterName] = useState('null');
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [recordsPerPage, setRecordsPerPage] = useState(10);
    const [searchQuery, setSearchQuery] = useState("");
    const [firstIndex, setFirstIndex] = useState(0);
    const [lastIndex, setLastIndex] = useState(0);

    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [pageRange, setPageRange] = useState([0, 10]); // Initial range [0, 10]
    const [searchTerm, setSearchTerm] = useState('');
    const [activeMenu, setActiveMenu] = useState(AdminSaleMenu);

    const [formData, setFormData] = useState({
        fdt: '',
        tdt: '',
        zoneId: '',
        schlId: '',
        uid: '',
        userId: '',
        uname: ''
    });
    const students = useSelector(selectStudents);
    const [schlList, setSchlList] = useState([]);
    const [reportData, setReportData] = useState([]);
    useEffect(() => {

        if (userdata?.pageIds?.length > 0 && userdata?.role === '2') {
            const pid = userdata?.pageIds?.find(item => item === 1);
            if (pid === 1) {
                setActiveMenu(AdminSaleMenu);
                // console.log('hhi')
            } else {
                setActiveMenu(UserSaleMenu);
            }
        }
    }, []);

    useEffect(() => {
        if (userdata?.role === '1') {
            dispatch(fetchUserSaleData());
        } else {
            const data = {
                userId: userdata?.ID
            };
            dispatch(fetchUserSaleData(data));
        }
        dispatch(fetchStudentData());
        dispatch(fetchSubUser());

    }, [dispatch]);

    if (!getItems) {
        return <h1>Loading...</h1>;
    }

    // console.log(getItems);

    const compData = Array.isArray(reportData.data) ? reportData.data.map((item, index) => (
        {
            srNo: item.ID,
            dt: item.DT,
            schl_stkId: item.schl_stkId,
            adsaleId: item.adsaleId,
            memo: item.memo,
            studNm: item.studNm,
            std: item.std,
            div: item.div,
            totqty: item.totqty,
            totamt: item.totamt,
            gst: item.gst,
            gst_val: item.gst_val,
            sts: item.sts,
            payableamt: item.payableamt,
            paymode: item.paymode,
            bnkNm: item.bnkNm,
            paidamt: item.paidamt,
            chqno: item.chqno,
            itemId: item.itemId,
            itemNm: item.itemNm,
            qty: item.qty,
            bqty: item.bqty,
            size: item.size,
            disrate: item.disrate,
            disamt: item.disamt,
            serialNumber: index + 1
        }
    )) : [];


    const handleSort = (event, id) => {
        const isAsc = orderBy === id && order === 'asc';
        if (id !== '') {
            setOrder(isAsc ? 'desc' : 'asc');
            setOrderBy(id);
        }
    };
    const handleSelectAllClick = (event) => {
        if (event.target.checked) {
            const newSelecteds = compData.map((n) => n.name);
            setSelected(newSelecteds);
            return;
        }
        setSelected([]);
    };

    const handleClick = (event, name) => {
        const selectedIndex = selected.indexOf(name);
        let newSelected = [];
        if (selectedIndex === -1) {
            newSelected = newSelected.concat(selected, name);
        } else if (selectedIndex === 0) {
            newSelected = newSelected.concat(selected.slice(1));
        } else if (selectedIndex === selected.length - 1) {
            newSelected = newSelected.concat(selected.slice(0, -1));
        } else if (selectedIndex > 0) {
            newSelected = newSelected.concat(
                selected.slice(0, selectedIndex),
                selected.slice(selectedIndex + 1)
            );
        }
        setSelected(newSelected);
    };



    const totalCount = compData.length;
    const npages = Math.ceil(totalCount / recordsPerPage);
    const numbers = Array.from({ length: npages }, (_, i) => i + 1);


    const handleSearchChange = (event) => {
        setSearchTerm(event.target.value);
        setCurrentPage(1); // Reset to first page on search
    };

    const filteredData = (Array.isArray(compData) ? compData : []).filter(item =>
        item?.studNm?.toLowerCase().includes(searchTerm.toLowerCase()) ||
        item?.memo?.toLowerCase().includes(searchTerm.toLowerCase())
    );
    // console.log(filteredData);

    const totqty = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totqty), 0);
    const totamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.totamt), 0);
    const totpaidamt = filteredData?.reduce((acc, sum) => acc + parseFloat(sum.paidamt), 0);

    const dataFiltered = applyFilter({
        inputData: filteredData,
        comparator: getComparator(order, orderBy),
    });

    const totalPages = Math.ceil(dataFiltered.length / itemsPerPage);
    const displayedData = dataFiltered.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);


    const pageNumbers = Array.from({ length: totalPages }, (_, index) => index + 1);
    const visiblePageNumbers = pageNumbers.slice(pageRange[0], pageRange[1]);

    const handleNextPageRange = () => {
        setPageRange([pageRange[0] + 5, pageRange[1] + 5]);
    };

    const handlePreviousPageRange = () => {
        setPageRange([pageRange[0] - 5, pageRange[1] - 5]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (event) => {
        setItemsPerPage(Number(event.target.value));
        setCurrentPage(1); // Reset to first page on change
    };
    // console.log(displayedData);

    const fields = [
        { label: 'From Date', name: 'fdt', type: 'date' },
        { label: 'To Date', name: 'tdt', type: 'date' },
        // { label: 'Barcode', name: 'freight_ch' },
    ];

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value.toUpperCase()
        });
    };

    const handleDropdownChange = (e, dropdownType) => {
        const { value } = e.target;
        setFormData({
            ...formData,
            [dropdownType]: value
        });
        if (dropdownType === 'uid') {
            fetchPageAssignSchools(value);
            const userId = subusers?.data?.find(item => item.ID === value)?.uId;
            const usernm = subusers?.data?.find(item => item.ID === value)?.uname;
            setFormData(prev => ({
                ...prev,
                userId: userId,
                uname: usernm
            }));
        }
    };


    const fetchPageAssignSchools = async (id) => {

        try {
            const response = await axios.get(`${baseUrl}?apicall=getUserWisePageAssign&uid=${id}`);
            setSchlList(response?.data?.data);
            // console.log(response.data)

        } catch (error) {
            console.error('Error fetching info list:', error);
        }
    };

    const dropdownOrdType = [

        {
            label: 'User',
            id: 'uid',
            options: subusers?.data || [],
            value: formData.uid,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'uid', value: newValue ? newValue.ID : '' } }, 'uid'),
            getOptionLabel: (option) => option.uname || '',
            isOptionEqualToValue: (option, value) => option.ID === value.ID,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.ID === value) || null;
                }
                return null;
            },
            bold: true,
        },
        {
            label: 'School',
            id: 'schlId',
            options: schlList?.subuser_info || [],
            value: formData.schlId,
            onChange: (newValue) => handleDropdownChange({ target: { name: 'schlId', value: newValue ? newValue.schlId : '' } }, 'schlId'),
            getOptionLabel: (option) => option.schlcd || '',
            isOptionEqualToValue: (option, value) => option.schlId === value.schlId,
            valueFinder: (options, value) => {
                if (Array.isArray(options)) {
                    return options.find(item => item.schlId === value) || null;
                }
                return null;
            },
            bold: true,
        },
    ];

    const handleSearch = (e) => {
        e.preventDefault();

        dispatch(fetchUserSaleReport(formData))
            .unwrap()
            .then((result) => {
                // Handle success
                console.log('POST request successful!', result);
                setReportData(result);
                // alert("Admin Sale Added");    
                // window.location.reload();
                // You may want to update your component state or perform any other action
            })
            .catch((error) => {
                // Handle error
                console.error('Error while making POST request:', error);
                // You may want to display an error message to the user or perform any other action
            });
    };
    return (
        <>
            {/* <Titlebar data={ === '2' ? UserSaleMenu : AdminSaleMenu} /> */}
            <Titlebar data={adminSaleReport} />
            <div style={{ margin: '1% 0.5%' }}>
                <h2>User Sale Report</h2>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Paper style={{ padding: '3vh', margin: '0' }}>



                            <Grid container spacing={0.5}>
                                {fields.map((field) => (
                                    <DateInputComponent2
                                        key={field.name}
                                        formData={formData}
                                        handleDateChange={handleInputChange}
                                        handleInputChange={handleInputChange}
                                        styled={styled}
                                        inputStyles={inputStyles}
                                        isDesktop={isDesktop}
                                        field={field}
                                    />
                                ))}

                                {
                                    dropdownOrdType?.map((drop) => (
                                        <Dropdown
                                            key={drop.label}
                                            label={drop.label}
                                            id={drop.id}
                                            options={drop.options}
                                            value={drop.value}
                                            onChange={drop.onChange}
                                            isDesktop={isDesktop}
                                            getOptionLabel={drop.getOptionLabel}
                                            isOptionEqualToValue={drop.isOptionEqualToValue}
                                            valueFinder={drop.valueFinder}  // Pass `valueFinder` function here

                                        />
                                    ))
                                }



                                <Grid item xs={12} textAlign="center">
                                    <Button variant="contained" color="primary" onClick={handleSearch}>Search</Button>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} textAlign="center" style={{ marginTop: '4%' }}>
                            </Grid>

                            <div style={{ margin: '2% 5%' }}>
                                <ReactToPrint
                                    trigger={() => <Button variant="contained" color="primary">Print</Button>}
                                    content={() => componentRef.current}
                                />
                            </div>

                            <SearchTable
                                handleItemsPerPageChange={handleItemsPerPageChange}
                                searchTerm={searchTerm}
                                handleSearchChange={handleSearchChange}
                                totalItems={filteredData?.length}
                            />


                            <div ref={componentRef}>
                                {formData.uname !== '' && <h3>User Name: {formData.uname}</h3>}
                                <TableContainer style={{ marginTop: '2%', border: '1px solid #ccc' }} >
                                    <Table>
                                        <TableHeader
                                            headCells={[
                                                { id: 'srNo', label: 'Sr.No' },
                                                { id: 'dt', label: 'Date' },
                                                { id: 'memo', label: 'Bill No.' },
                                                { id: 'studNm', label: 'Student' },
                                                // { id: 'itemNm', label: 'Item' },
                                                // { id: 'size', label: 'Size' },
                                                { id: 'totqty', label: 'Total Qty' },
                                                // { id: 'disrate', label: 'Rate' },
                                                { id: 'totamt', label: 'Total Amt' },
                                                { id: 'paidamt', label: 'Paid Amt' },
                                                { id: '', label: 'Bal Amt' },
                                                { id: '', label: 'View' },
                                                // { id: 'edit', label: 'Edit' },
                                                // { id: 'delete', label: 'Delete' }
                                            ]}

                                            order={order}
                                            orderBy={orderBy}
                                            onRequestSort={handleSort}
                                            numSelected={selected.length}
                                            rowCount={compData.length}
                                            onSelectAllClick={handleSelectAllClick}
                                        />
                                        <tbody>


                                            {displayedData && displayedData.length > 0 ? (
                                                <>
                                                    {displayedData.map((row) => (
                                                        <TableBody3
                                                            key={row.srNo}
                                                            id={row.srNo}
                                                            dt={row.dt}
                                                            schl_stkId={row.schl_stkId}
                                                            adsaleId={row.adsaleId}
                                                            memo={row.memo}
                                                            studNm={row.studNm}
                                                            std={row.std}
                                                            div={row.div}
                                                            totqty={row.totqty}
                                                            totamt={row.totamt}
                                                            paidamt={row.paidamt}
                                                            gst={row.gst}
                                                            gst_val={row.gst_val}
                                                            sts={row.sts}
                                                            itemId={row.itemId}
                                                            itemNm={row.itemNm}
                                                            qty={row.qty}
                                                            bqty={row.bqty}
                                                            size={row.size}
                                                            disrate={row.disrate}
                                                            disamt={row.disamt}
                                                            serialNumber={row.serialNumber}
                                                            selected={selected.indexOf(row.name) !== -1}
                                                            handleClick={(event) => handleClick(event, row.name)}
                                                        />
                                                    ))}
                                                    <TableBottom2
                                                        totamt={totamt}
                                                        totpaidamt={totpaidamt}
                                                        totqty={totqty}
                                                    />
                                                </>
                                            ) : (
                                                <tr>
                                                    <td colSpan={12} style={{ textAlign: "center", padding: "10px" }}>
                                                        No data available
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </Table>
                                </TableContainer>
                            </div>

                            <Pagination
                                currentPage={currentPage}
                                handlePageChange={handlePageChange}
                                handlePreviousPageRange={handlePreviousPageRange}
                                visiblePageNumbers={visiblePageNumbers}
                                pageNumber={pageNumbers}
                                pageRange={pageRange}
                                totalPages={totalPages}
                                handleNextPageRange={handleNextPageRange}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </div>

        </>
    );
}

export default UserSaleReportReg;
